import ReactGA from 'react-ga';

export const initializeAnalytics = (
  trackingId: string
) => ReactGA.initialize(trackingId);

export const sendEvent = (
  { category, action }: { category: string; action: string }
) => ReactGA.event({ category, action });
